import { useCurrentPlatformContext } from "@/contexts";
import { CapabilitySet, EMPTY_CAPABILITY_SET } from "@/types/capability.types";

/**
 * Capability set the current user holds on the active platform's PLATFORM
 * node. Empty while the platform is unresolved or when the BE has not shipped
 * the `capabilities` field yet — under strict RBAC an empty set denies (fail closed).
 */
export const usePlatformCapabilities = (): CapabilitySet => {
  const { platform } = useCurrentPlatformContext();
  return platform?.capabilities ?? EMPTY_CAPABILITY_SET;
};
